import { TFunc, useTranslation } from 'libs/i18n';
import { TableColumn } from 'libs/ui';

import { renderNameMobile } from './renders/name';
import { renderSize } from './renders/size';
import { DocumentsColumnArgs, DocumentsListItem } from './types';

const getColumns = (
  t: TFunc,
  { onClickDownload, onClickPreview }: DocumentsColumnArgs
): TableColumn<DocumentsListItem>[] => [
  {
    field: 'name',
    title: t('account.documents.columns.name'),
    renderCell: (item) =>
      renderNameMobile(
        item,
        t,
        () => onClickDownload(item),
        () => onClickPreview(item)
      ),
  },
  {
    field: 'size',
    title: t('account.documents.columns.size'),
    renderCell: (item) => renderSize(item.size, t),
  },
];

export const useMobileColumns = (args: DocumentsColumnArgs) => {
  const { t } = useTranslation();
  const columns = getColumns(t, args);

  return columns;
};
